<template>
    <div class="layer-container">
        <el-card class="box-card">
            <div slot="header" class="clearfix header">
                <span>图层-{{lname}}</span>
                <div>

                </div>
            </div>
            <div class="content">
                <el-descriptions title="存储信息" direction="vertical" :column="2" border>
                    <el-descriptions-item label="图层别名">{{lname}}</el-descriptions-item>
                    <el-descriptions-item label="图层标题">{{layer.title}}</el-descriptions-item>
                    <el-descriptions-item v-if="layer.type == 'OGC'" label="存储空间">{{layer.storeName}}</el-descriptions-item>
                </el-descriptions>

                <el-descriptions class="desc" title="坐标系" direction="vertical" :column="1" border v-if="layer.type == 'OGC'">
                    <el-descriptions-item label="坐标系">{{layer.srs}}</el-descriptions-item>
                    <el-descriptions-item label="边框">
                        <div class="tabel">
                            <div class="info">
                                <span>最小X：</span>
                                <el-tag type="info">{{layer.minX}}</el-tag>
                            </div>
                            <div class="info">
                                <span>最小Y：</span>
                                <el-tag type="info">{{layer.minY}}</el-tag>
                            </div>
                            <div class="info">
                                <span>最大X：</span>
                                <el-tag type="info">{{layer.maxX}}</el-tag>
                            </div>
                            <div class="info">
                                <span>最大Y：</span>
                                <el-tag type="info">{{layer.maxY}}</el-tag>
                            </div>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="纬度/经度边框">
                        <div class="tabel">
                            <div class="info">
                                <span>最小X：</span>
                                <el-tag type="info">{{layer.lonLatMinX}}</el-tag>
                            </div>
                            <div class="info">
                                <span>最小Y：</span>
                                <el-tag type="info">{{layer.lonLatMinY}}</el-tag>
                            </div>
                            <div class="info">
                                <span>最大X：</span>
                                <el-tag type="info">{{layer.lonLatMaxX}}</el-tag>
                            </div>
                            <div class="info">
                                <span>最大Y：</span>
                                <el-tag type="info">{{layer.lonLatMaxY}}</el-tag>
                            </div>
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
                <el-descriptions class="desc" title="样式" direction="vertical" :column="1" border v-if="layer.type == 'OGC'">
                    <el-descriptions-item label="样式名称">
                        <el-input class="input" v-model="layer.style" placeholder="请输入样式名称"></el-input>
                        <span class="style-tip" v-show="!styleNameTip">样式名称不能一样</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="样式上传" :span="2">
                        <el-upload class="upload-demo" ref="upload" :action="styleUploadAction" :limit="1" :headers="uploadHeaders" :show-file-list="false" :file-list="styleFileList" :on-error="uploadStyleFileError" :on-success="uploadStyleFile" :before-upload="beforeStyleUpload" :data="uploadData">
                            <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传.sld文件，且不超过1MB</div>
                        </el-upload>
                    </el-descriptions-item>
                    <el-descriptions-item label="样式内容">
                        <pre>{{formatStyleContent}}</pre>
                    </el-descriptions-item>
                </el-descriptions>
                <div class="service" v-if="layer.type == 'OGC'">
                    <div class="el-descriptions__title">OGC服务</div>
                    <el-table :data="layer.ogcList" style="width: 100%;height: 520px;" class="tabel" border>
                        <el-table-column
                            prop="name"
                            label="服务名称"
                            width="260">
                        </el-table-column>
                        <el-table-column
                            prop="path"
                            label="路径">
                        </el-table-column>
                    </el-table>
                </div>
                <div class="service" v-if="layer.type == 'REST'">
                    <div class="el-descriptions__title">REST服务</div>
                    <el-table :data="layer.rest" style="width: 100%;height: 510px;" class="tabel" border>
                        <el-table-column
                            prop="path"
                            label="路径">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import { detailLayer, checkStyleName } from '../../api/layerApi'
import { formatXml } from '../../utils/xmlUtils'
import { getToken } from '@/api/auth.js'
import { baseURL } from '@/api/apiConfig.js'
export default {
    name: 'DetailsLayer',
    components: {},
    data() {
        return {
            lname: '',
            lid: '',
            layer: '',
            ogcArr: [],
            styleFileList: [],
            styleNameTip: true,
            styleUploadAction: baseURL + '/geoserver/style/add?t=' + new Date().getTime(),
            uploadData: {},
            formatStyleContent: '',
            uploadHeaders: {
                Authorization: getToken()
            }
        }
    },
    mounted() {
        this.lname = this.$route.query.l
        this.lid = this.$route.query.lid
        this.loadLayerInfo()
    },
    beforeDestroy() {
    },
    methods: {
        loadLayerInfo() {
            detailLayer({ id: this.lid }).then(res => {
                if (res.data.code == 200) {
                    this.layer = res.data.data
                    this.formatStyleContent = formatXml(this.layer.styleContent)
                } else {
                    console.log('查询失败')
                }
            })
        },
        uploadStyleFile(res, file, fileList) {
            if (res.code == 200) {
                this.$message.success('上传成功!')
                this.$refs.upload.clearFiles()
                this.formatStyleContent = formatXml(res.msg)
            }
        },
        uploadStyleFileError(err, file, fileList) {
            console.log(err)
        },
        async styleInputBlur() {
            this.styleNameTip = await this.checkStyleName()
        },
        async beforeStyleUpload(file) {
            const isSld = file.name.match(/[^.]+$/)[0] === 'sld'
            const isLt1m = file.size / 1024 / 1024 < 1

            if (!isSld) {
                this.$message.error('上传文件只能是 sld 格式!')
            }
            if (!isLt1m) {
                this.$message.error('上传文件大小不能超过 1MB!')
            }
            if (!this.layer.style) {
                this.$message.error('样式名称不能为空!')
            }
            this.uploadData = {
                id: this.lid,
                name: this.layer.style
            }
            this.styleNameTip = await this.checkStyleName()

            if (!(isSld && isLt1m && this.styleNameTip)) {
                return Promise.reject(isSld && isLt1m && this.styleNameTip)
            }
        },
        async checkStyleName() {
            var result
            await checkStyleName({ name: this.layer.style }).then(res => {
                result = res.data.data
            })
            return result
        }
    },
    watch: {
        $route(to, from) {
            this.lname = to.query.l
            this.lid = to.query.lid
            this.loadLayerInfo()
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/.el-upload-dragger{
    width: 320px !important;
    height: 140px !important;
    display: flex;
    flex-direction: column;
    .el-icon-upload{
        margin: auto !important;
    }
}
/deep/.el-upload-list--text{
    width: 300px !important;
}
/deep/.el-descriptions-item__content{
    .tabel{
        display: flex;
        .info{
            padding: 0 30px 0 0;
        }
    }
}
/deep/.td:last-child{
    border: 1px solid #EBEEF5;
}
.input{
    width: 200px;
}
.layer-container {
    background: #f2f2f2;
    height: calc(100vh - 111px);
    overflow-y: auto;
    overflow-x: hidden;
    .service{
        padding: 20px 0;
        .tabel {
            margin-top: 20px;
        }
    }
    .desc{
        margin-top: 20px;
        .style-tip{
            margin-left: 10px;
            color: red;
        }
    }
}
</style>

